import { isFilled } from "@prismicio/client";
import { PrismicNextImage } from "@prismicio/next";

/**
 * @typedef {import("@prismicio/client").Content.ProjectPictureSlice} ProjectPictureSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ProjectPictureSlice>} ProjectPictureProps
 * @type {import("react").FC<ProjectPictureProps>}
 */
const ProjectPicture = ({ slice }) => {
  const pictures = Array.isArray(slice.primary.pictures)
    ? slice.primary.pictures
        .filter((item) => isFilled.image(item.picture))
        .slice(0, 2)
    : [];

  if (pictures.length === 0) {
    return null;
  }

  const isSingle = pictures.length === 1;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <div className="flex w-full items-start gap-[28px]">
        {pictures.map((item, index) => (
          <div
            key={`picture-${index}`}
            className={`relative h-[337px] overflow-hidden rounded-[20px] ${isSingle ? "w-full" : "min-w-0 flex-1"}`}
          >
            <PrismicNextImage
              field={item.picture}
              fill
              className="object-cover"
              sizes={
                isSingle
                  ? "(max-width: 1024px) 100vw, 784px"
                  : "(max-width: 1024px) 50vw, 378px"
              }
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProjectPicture;
